"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var index_1 = __importDefault(require("../../../components/Form/ButtomComponent/index"));
var InputSearch_1 = __importDefault(require("../../../components/InputSearch"));
var SectionTitle_1 = __importDefault(require("../../../components/SectionTitle"));
var TableComponent_1 = __importDefault(require("../../../components/TableComponent"));
var TablePaginationComponent_1 = __importDefault(require("../../../components/TablePaginationComponent"));
var ChipStatusContainer_1 = __importDefault(require("../../../containers/ChipStatusContainer"));
var services_1 = require("../../../services");
var locale_es_1 = __importDefault(require("../../../translations/locale-es"));
var utilities_1 = require("../../../utilities");
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var react_toastify_1 = require("react-toastify");
var DialogFilterListContainer_1 = __importDefault(require("../../../containers/DialogFilterListContainer"));
var HelperSearchOrFilterContainer_1 = __importDefault(require("../../../containers/HelperSearchOrFilterContainer"));
var context_1 = require("../../../context");
var hooks_1 = require("../../../hooks");
var useDisclosure_1 = __importDefault(require("../../../hooks/useDisclosure"));
var styles_1 = require("../../../styles");
var ClientCardsReport = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var showBoundary = (0, react_error_boundary_1.useErrorBoundary)().showBoundary;
    var _j = (0, react_router_dom_1.useSearchParams)(), searchParams = _j[0], setSearchParams = _j[1];
    var disclosureFilterDialog = (0, useDisclosure_1.default)();
    var headerContainer = (0, react_1.useRef)(null);
    var termSearch = searchParams.get('term');
    var merchantIdentifier = searchParams.get('merchantIdentifier');
    var campaignIdentifier = searchParams.get('campaignIdentifier');
    var initialFilterListValue = utilities_1.QueryParamsUtils.getQueryParamsMultipleInitialValues({
        initialParamValues: { 'status[]': [] },
        queryParams: searchParams,
    });
    var _k = (0, context_1.useGlobalLoading)(), updateLoading = _k.updateLoading, updateLoadingDescription = _k.updateLoadingDescription, resetLoading = _k.resetLoading;
    var getAllMerchant = (0, hooks_1.useFetchAllMerchants)({
        onSuccess: function (data) {
            var _a;
            var firstMerchant = merchantIdentifier
                ? data === null || data === void 0 ? void 0 : data.find(function (cam) { return cam.id === merchantIdentifier; })
                : data[0];
            searchParams.set('merchantIdentifier', (_a = firstMerchant === null || firstMerchant === void 0 ? void 0 : firstMerchant.id) !== null && _a !== void 0 ? _a : '');
            setSearchParams(searchParams);
        },
    });
    var getCampaigns = (0, hooks_1.useFetchAllCampaignsByMerchantId)(merchantIdentifier !== null && merchantIdentifier !== void 0 ? merchantIdentifier : '', {
        enabled: !!merchantIdentifier,
        onSuccess: function (data) {
            var _a;
            var firstCampaign = campaignIdentifier
                ? data === null || data === void 0 ? void 0 : data.find(function (cam) { return cam.id === campaignIdentifier; })
                : data[0];
            searchParams.set('campaignIdentifier', (_a = firstCampaign === null || firstCampaign === void 0 ? void 0 : firstCampaign.id) !== null && _a !== void 0 ? _a : '');
            setSearchParams(searchParams);
        },
    });
    var _l = (0, hooks_1.useFetchAllClientCardsReport)({
        merchant_id: merchantIdentifier !== null && merchantIdentifier !== void 0 ? merchantIdentifier : '',
        campaign_id: campaignIdentifier !== null && campaignIdentifier !== void 0 ? campaignIdentifier : '',
    }), clientCardsData = _l.data, isLoading = _l.isLoading, isFetching = _l.isFetching;
    var handleChangeMerchant = function (merchant) {
        var _a;
        searchParams.set('merchantIdentifier', (_a = merchant === null || merchant === void 0 ? void 0 : merchant.id) !== null && _a !== void 0 ? _a : '');
        searchParams.delete('campaignIdentifier');
        setSearchParams(searchParams);
    };
    var handleChangeCampaign = function (campaign) {
        var _a;
        searchParams.set('campaignIdentifier', (_a = campaign === null || campaign === void 0 ? void 0 : campaign.id) !== null && _a !== void 0 ? _a : '');
        setSearchParams(searchParams);
    };
    var handleDownloadExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, response, fileName, url, link, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!merchantIdentifier || !campaignIdentifier) {
                        react_toastify_1.toast.info('Por favor, seleccione un Cliente B2B y su Campaña');
                        return [2 /*return*/];
                    }
                    params = {
                        merchant_id: merchantIdentifier !== null && merchantIdentifier !== void 0 ? merchantIdentifier : '',
                        campaign_id: campaignIdentifier !== null && campaignIdentifier !== void 0 ? campaignIdentifier : '',
                        query: __assign(__assign({}, utilities_1.FilterHelper.getSearchOptional((_a = searchParams.get('term')) !== null && _a !== void 0 ? _a : '')), utilities_1.FilterHelper.formatFilterMultipleOptional(initialFilterListValue)),
                    };
                    updateLoading(true);
                    updateLoadingDescription('Iniciando descarga, por favor espere...');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, services_1.api.get("/api/v1/reports/merchants/".concat(params.merchant_id, "/campaigns/").concat(params.campaign_id, "/client-cards/report"), {
                            params: params.query,
                            responseType: 'blob',
                            onDownloadProgress: function (progressEvent) {
                                var _a;
                                var currentProgress = Math.round((progressEvent.loaded * 100) / ((_a = progressEvent === null || progressEvent === void 0 ? void 0 : progressEvent.total) !== null && _a !== void 0 ? _a : 0));
                                updateLoadingDescription("Descargando archivo: ".concat(currentProgress, "%"));
                                if (currentProgress === 100) {
                                    resetLoading();
                                }
                            },
                        })];
                case 2:
                    response = _b.sent();
                    fileName = "reporte-tarjetas-".concat((0, utilities_1.nowDateFormat)({
                        formatTypeDate: 'dd-MM-yyyy-HHmmss',
                    }), ".xlsx");
                    if (response.data) {
                        url = window.URL.createObjectURL(new Blob([response.data]));
                        link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    resetLoading();
                    (0, utilities_1.handleError)(error_1);
                    showBoundary(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(styles_1.WrapperPage, { children: [(0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ elevation: 0, sx: { marginBottom: '30px' }, ref: headerContainer }, { children: [(0, jsx_runtime_1.jsx)(SectionTitle_1.default, { title: "Reporte de Tarjetas", renderRight: (0, jsx_runtime_1.jsxs)(index_1.default.Filter, __assign({ variant: "outlined", size: "large", color: "inherit", onClick: handleDownloadExcel }, { children: [(0, jsx_runtime_1.jsx)(material_1.Icon, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Download, {}) }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "p", sx: {
                                        display: { xs: 'none', sm: 'block' },
                                        margin: { xs: '0', sm: '0 0 0 8px' },
                                    } }, { children: "Exportar en Excel" }))] })) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { marginTop: '10px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "h5", fontWeight: "bold" }, { children: "Seleccionar el Cliente B2B y su Campa\u00F1a" })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                    marginTop: '7px',
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        sm: 'repeat(3, 1fr)',
                                    },
                                    gap: '10px',
                                    alignItems: 'flex-end',
                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Autocomplete, { disablePortal: true, options: (_a = getAllMerchant.data) !== null && _a !== void 0 ? _a : [], loading: getAllMerchant.isLoading, getOptionLabel: function (option) { return option.company_name; }, onChange: function (ev, values) { return handleChangeMerchant(values); }, value: (_c = (_b = getAllMerchant.data) === null || _b === void 0 ? void 0 : _b.find(function (mer) { return mer.id === merchantIdentifier; })) !== null && _c !== void 0 ? _c : null, isOptionEqualToValue: function (option, value) { return value.id === option.id; }, id: "combo-box-client-b2b", sx: { width: '100%' }, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(material_1.TextField, __assign({}, params, { label: "Cliente B2B", InputProps: __assign(__assign({}, params.InputProps), { endAdornment: ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [getAllMerchant.isLoading ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }) }))); } }), (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { disablePortal: true, options: (_d = getCampaigns.data) !== null && _d !== void 0 ? _d : [], loading: getCampaigns.isLoading, getOptionLabel: function (option) { return option.description; }, onChange: function (ev, values) { return handleChangeCampaign(values); }, value: (_f = (_e = getCampaigns.data) === null || _e === void 0 ? void 0 : _e.find(function (ca) { return ca.id === campaignIdentifier; })) !== null && _f !== void 0 ? _f : null, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, id: "combo-box-campaign", sx: { width: '100%' }, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(material_1.TextField, __assign({}, params, { label: "Campa\u00F1a", InputProps: __assign(__assign({}, params.InputProps), { endAdornment: ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [getCampaigns.isLoading ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })) }) }))); } })] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                            display: 'grid',
                            gap: '5px',
                            marginTop: '1rem',
                        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    width: '100%',
                                    gap: '10px',
                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                                            width: { xs: '100%', sm: '50%' },
                                        } }, { children: (0, jsx_runtime_1.jsx)(InputSearch_1.default, { placeholder: "Buscar tarjeta del cliente", isPagination: true }) })), (0, jsx_runtime_1.jsxs)(index_1.default.Filter, __assign({ variant: "outlined", size: "large", color: "inherit", onClick: disclosureFilterDialog.onOpen }, { children: [(0, jsx_runtime_1.jsx)(material_1.Icon, { children: (0, jsx_runtime_1.jsx)(icons_material_1.ManageSearchOutlined, {}) }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "p", sx: {
                                                    display: { xs: 'none', sm: 'block' },
                                                    margin: { xs: '0', sm: '0 0 0 8px' },
                                                } }, { children: "Filtros" }))] })), (0, jsx_runtime_1.jsx)(DialogFilterListContainer_1.default, { open: disclosureFilterDialog.isOpen, onClose: disclosureFilterDialog.onClose, optionFilterList: services_1.optionClientCardFilterList, filterList: initialFilterListValue })] })), (0, jsx_runtime_1.jsx)(styles_1.HelperText, { children: "Buscar por: Tarjeta, Datos del cliente (Nombre, Apellidos, Correo, N\u00FAmero de Documento), Campa\u00F1a." })] })), (0, jsx_runtime_1.jsx)(HelperSearchOrFilterContainer_1.default, { search: termSearch !== null && termSearch !== void 0 ? termSearch : '', filterList: initialFilterListValue })] })), (0, jsx_runtime_1.jsxs)(material_1.Paper, { children: [(0, jsx_runtime_1.jsx)(TableComponent_1.default, { variant: "normal", isLoading: isLoading || isFetching, rows: (_g = clientCardsData === null || clientCardsData === void 0 ? void 0 : clientCardsData.data) !== null && _g !== void 0 ? _g : [], keyExtractor: function (item) { return item.card_id; }, stickyHeader: true, maxHeight: "calc(100vh - ".concat(headerContainer.current &&
                            ((_h = headerContainer.current) === null || _h === void 0 ? void 0 : _h.clientHeight) + 240, "px)"), columns: [
                            {
                                label: 'Datos del Cliente',
                                field: 'client',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var _b, _c;
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: 'h6', fontWeight: "500", fontSize: 15, variant: "body1" }, { children: (0, utilities_1.getFullNameClient)({
                                                    first_name: row.client_first_name,
                                                    first_last_name: row.client_first_last_name,
                                                    second_name: (_b = row.client_second_name) !== null && _b !== void 0 ? _b : '',
                                                    second_last_name: (_c = row.client_second_last_name) !== null && _c !== void 0 ? _c : '',
                                                }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: 'p', fontSize: 15 }, { children: "".concat(row.client_document_type, " - ").concat(row.client_document_number) }))] }));
                                },
                            },
                            {
                                label: 'Otros Datos del Cliente',
                                field: 'email_gender',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: 'h6', fontWeight: "500", variant: "body1" }, { children: row.client_email })), (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ component: 'p', variant: "body1" }, { children: ["G\u00E9nero: ", locale_es_1.default['gender'][row.client_gender]] }))] }));
                                },
                            },
                            {
                                label: 'Tarjeta',
                                field: 'card_pan',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.card_pan;
                                },
                            },
                            {
                                label: 'Estado',
                                field: 'status',
                                align: 'center',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(ChipStatusContainer_1.default, { status: row.card_status }));
                                },
                            },
                            {
                                label: 'Fecha de Registro',
                                field: 'created_at',
                                align: 'right',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return (0, utilities_1.formatDate)({ date: row.card_created_at });
                                },
                            },
                        ] }), (0, jsx_runtime_1.jsx)(TablePaginationComponent_1.default, { total: (clientCardsData === null || clientCardsData === void 0 ? void 0 : clientCardsData.data)
                            ? clientCardsData === null || clientCardsData === void 0 ? void 0 : clientCardsData.metadata.pagination.total
                            : 0 })] })] }));
};
exports.default = ClientCardsReport;
